import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Layout from '../components/common/Layout';
import OnboardingTermsOfService from '../components/onboarding/OnboardingTermsOfService';
import OnboardingTwoFactorSetup from '../components/onboarding/OnboardingTwoFactorSetup';
import OnboardingWalletExplanation from '../components/onboarding/OnboardingWalletExplanation';
import styles from '../styles/views/Onboarding.module.scss';

type OnboardingStep = 'terms' | '2fa' | 'wallets';

const Onboarding = () => {
  const [currentStep, setCurrentStep] = useState<OnboardingStep>('terms');
  const navigate = useNavigate();

  console.log("🎯 Onboarding component mounted");

  React.useEffect(() => {
    console.log("🎯 Onboarding useEffect running, current step:", currentStep);
    return () => console.log("🎯 Onboarding component unmounting");
  }, [currentStep]);

  const handleStepComplete = (step: OnboardingStep) => {
    switch (step) {
      case 'terms':
        setCurrentStep('2fa');
        break;
      case '2fa':
        setCurrentStep('wallets');
        break;
      case 'wallets':
        // Complete onboarding, redirect to credit lines
        navigate('/');
        break;
    }
  };

  const getStepTitle = () => {
    switch (currentStep) {
      case 'terms':
        return 'Terms of Service';
      case '2fa':
        return 'Set Up Two-Factor Authentication';
      case 'wallets':
        return 'Your Credit Line Wallets';
      default:
        return 'Welcome';
    }
  };

  const getStepNumber = () => {
    switch (currentStep) {
      case 'terms':
        return 1;
      case '2fa':
        return 2;
      case 'wallets':
        return 3;
      default:
        return 1;
    }
  };

  return (
    <Layout
      pageTitle={`Onboarding - ${getStepTitle()} - Liquid Credit`}
      hideHeader
      pageBodyClassName={styles.onboardingPage}
    >
      <div className={styles.onboardingContainer}>
        <div className={styles.stepIndicator}>
          <div className={styles.stepProgress}>
            <span className={styles.stepNumber}>{getStepNumber()}</span>
            <span className={styles.stepTotal}>of 3</span>
          </div>
          <h1 className={styles.stepTitle}>{getStepTitle()}</h1>
        </div>

        <div className={styles.stepContent}>
          {currentStep === 'terms' && (
            <OnboardingTermsOfService onComplete={() => handleStepComplete('terms')} />
          )}
          {currentStep === '2fa' && (
            <OnboardingTwoFactorSetup onComplete={() => handleStepComplete('2fa')} />
          )}
          {currentStep === 'wallets' && (
            <OnboardingWalletExplanation onComplete={() => handleStepComplete('wallets')} />
          )}
        </div>
      </div>
    </Layout>
  );
};

export default Onboarding;
